/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import i18next from 'i18next';
import { withRouter } from 'react-router-dom';

import Product from '~/modules/ecommerceCoreUI/containers/Product';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import ExternalLink from '~/modules/coreUI/components/basic/ExternalLink';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

export const CARD_WIDTH = 230;

const ItemsListViewUI = withMedia(styled.div`
  display: grid;
  width: 100%;

  grid-gap: ${props => props.theme.new.spacer}px;
  grid-template-columns: repeat(auto-fill, minmax(${CARD_WIDTH}px, 1fr));
`);

const ViewAllLink = (category, departmentId, departmentName, vendorID, vendorName) => (
  <Row fullWidth rightJustified>
    <Row>
      <ExternalLink url={urlFor('getTaxonLink', [category, departmentId, departmentName, vendorID, vendorName])}>
        <Label semiBold secondary>
          {i18next.t('eCommerceShops:ShopDetails.viewAllProducts')}
        </Label>
      </ExternalLink>
    </Row>
  </Row>
);

const CategoryProductsList = ({
  category, maxNumberOfCards, match, departmentId, departmentName,
}) => (
  <Column fullWidth>
    <Row fullWidth>
      <ItemsListViewUI>
        {category.products.map((product, index) => (
          index < maxNumberOfCards && (
            <Product
              isVertical
              productInfo={product}
              key={product.__id}
              isVendorProduct
              vendorInfo={{
                vendorID: match.params.vendorID,
                vendorName: match.params.vendorName,
              }}
              isHotDeal={category.caption === 'hot_deals'}
              isProduct
            />
          )
        ))}
      </ItemsListViewUI>
    </Row>
    <Spacer size={1.5} />
    {category.products.length > maxNumberOfCards && (
      ViewAllLink(category, departmentId, departmentName, match.params.vendorID, match.params.vendorName)
    )}
  </Column>
);


CategoryProductsList.propTypes = {
  category: PropTypes.shape(),
  maxNumberOfCards: PropTypes.number.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      vendorID: PropTypes.string.isRequired,
      vendorName: PropTypes.string.isRequired,
    }),
  }).isRequired,
  departmentId: PropTypes.string.isRequired,
  departmentName: PropTypes.string.isRequired,
};

CategoryProductsList.defaultProps = {
  category: null,
};

export default withRouter(CategoryProductsList);
